import { render, staticRenderFns } from "./StudyRecordGrades.vue?vue&type=template&id=7d65d9b8"
import script from "./StudyRecordGrades.vue?vue&type=script&lang=js"
export * from "./StudyRecordGrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports